import { Header } from '../../components/layout';
import { Sidebar } from '../../components/layout/Sidebar';
import {
  FiBarChart2, FiFileText, FiList,
  FiMinusCircle, FiPlusCircle, FiTrendingUp,
} from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts';
import { usePreferences } from '../../contexts/PreferencesContext';
import styles from './Home.module.css';

export function Home() {
  const navigate = useNavigate();
  const { user, canAccess } = useAuth();
  const { t } = usePreferences();
  const firstName = user?.name?.split(' ')[0] || 'Usuário';

  const allCards = [
    { labelKey: 'home.lancar', icon: FiPlusCircle,  path: '/lancar-receita', accent: 'receitas', highlightKey: 'home.receitas' },
    { labelKey: 'home.lancar', icon: FiMinusCircle, path: '/lancar-despesa', accent: 'despesas', highlightKey: 'home.despesas' },
    { labelKey: 'home.historico', icon: FiList,      path: '/lancamentos',    accent: null, highlightKey: null },
    { labelKey: 'home.cashflow',  icon: FiTrendingUp, path: '/cashflow',      accent: null, highlightKey: null },
    { labelKey: 'home.graficos',  icon: FiBarChart2,  path: '/graficos',      accent: null, highlightKey: null },
    { labelKey: 'home.relatorios', icon: FiFileText,  path: '/reports',       accent: null, highlightKey: null },
  ];
  const cards = allCards.filter((card) => canAccess(card.path));
  // Em "Todos os negocios" sobram 4 cartoes, e a grade de 3 colunas deixava um
  // buraco na segunda linha. Com 4, duas linhas cheias.
  const gridClass = cards.length === 4 ? `${styles.grid} ${styles.gridQuatro}` : styles.grid;

  return (
    <div className={styles.layout}>
      <Sidebar />
      <main className={styles.main}>
        <Header title={t('home.titulo')} />
        <div className={styles.content}>
          <h2 className={styles.greeting}>{t('home.saudacao', { name: firstName })}</h2>

          <div className={gridClass}>
            {cards.map((card, i) => (
              <button
                key={i}
                className={styles.card}
                onClick={() => navigate(card.path)}
              >
                <card.icon size={48} className={styles.cardIcon} />
                <span className={styles.cardLabel}>
                  {card.accent && card.highlightKey ? (
                    <>
                      {t(card.labelKey)}{' '}
                      <span className={styles[card.accent]}>{t(card.highlightKey)}</span>
                    </>
                  ) : t(card.labelKey)}
                </span>
              </button>
            ))}
          </div>

        </div>
      </main>
    </div>
  );
}